/* ASJ CUSTOM: Shop By Application mobile accordion controller.
   Progressive enhancement: panels render open in HTML (readable with no JS); this
   script collapses to a single-open accordion on load and wires toggling.
   Accessible: native <button> triggers, aria-expanded, aria-controls, keyboard + SR. */
(function () {
  function initAccordion(root) {
    var triggers = Array.prototype.slice.call(root.querySelectorAll('.asj-sba__acc-trigger'));
    if (!triggers.length) return;

    function setState(btn, open) {
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      var panel = document.getElementById(btn.getAttribute('aria-controls'));
      if (panel) panel.hidden = !open;
    }

    triggers.forEach(function (btn, i) {
      // collapse all but the first on init
      setState(btn, i === 0);
      btn.addEventListener('click', function () {
        var isOpen = btn.getAttribute('aria-expanded') === 'true';
        triggers.forEach(function (b) { setState(b, false); });
        if (!isOpen) setState(btn, true);
      });
    });
  }

  function init() {
    Array.prototype.slice
      .call(document.querySelectorAll('.asj-sba__accordion'))
      .forEach(initAccordion);
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init, { once: true });
})();
